// extracted by mini-css-extract-plugin
export default {"videoDesktop":"VideoDesktop_videoDesktop__gcN1d","videoInvisible":"VideoDesktop_videoInvisible__yXJTb","videoVisible":"VideoDesktop_videoVisible__+SrZE"};